










import {
  defineComponent,
  computed,
  useRoute,
  useStore,
  useRouter,
  useContext,
} from '@nuxtjs/composition-api'
import { Context } from '@nuxt/types'
import Mediator from '../components/Mediator.vue'
import { pageRequest } from '@/composition/pageRequest'
import { pageHead } from '@/packages'
import { yaHitPage } from '@/composition/ym'
import { breadcrumbsSchemaBuilder } from '@/composition/breadcrumbsSchemaBuilder'

export default defineComponent({
  name: 'ConstructorPage',
  components: {
    Mediator,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const context = useContext()
    const hideContent = computed(() => {
      return route.value.query?.result === 'success'
    })
    const breadcrumbs = computed(
      () => store.getters['breadcrumbs/GET_BREADCRUMBS']
    )
    router.beforeEach((_to, _from, next) => {
      setTimeout(() => {
        window.ymab(`metrika.${context.app.$config.VARIOQUB_CLIENT_ID}`, 'init')
      })
      next()
    })
    return {
      breadcrumbs,
      hideContent,
    }
  },
  async asyncData(ctx: Context) {
    return await pageRequest(ctx)
  },

  head() {
    const { seo } = this
    const defaultHead = pageHead(seo)
    defaultHead.script = []
    if (defaultHead.schema) {
      defaultHead.script = defaultHead.schema
        .filter((schema) => schema)
        .map((schema) => ({
          type: 'application/ld+json',
          json: JSON.parse(schema),
        }))
    }
    if (this.breadcrumbs) {
      defaultHead.script.push({
        type: 'application/ld+json',
        json: JSON.parse(
          breadcrumbsSchemaBuilder(this.breadcrumbs, 'https://www.rgs.ru')
        ),
      })
    }
    if (this.schemaProduct) {
      defaultHead.script.push({
        type: 'application/ld+json',
        json: this.schemaProduct,
      })
    }
    if (this.articleSeoSchema) {
      try {
        defaultHead.script.push({
          type: 'application/ld+json',
          json: JSON.parse(this.articleSeoSchema),
        })
      } catch {}
    }
    const path = this.$route?.path || ''
    if (path === '/dolg') {
      defaultHead.script.push({
        type: 'text/javascript',
        defer: 'defer',
        src: '/scripts/edna.js',
      })
    }
    if (path === this.$config.RGS_ONLINE_GAMES_PATH) {
      defaultHead.script.push({
        type: 'text/javascript',
        defer: 'defer',
        src: 'https://cdn.inappstory.ru/sdk/v3.8.0/dist/js/IAS.js',
      })
    }
    if (path === '/health/vasha-zashchita') {
      defaultHead.script.push({
        charset: 'utf-8',
        type: 'text/javascript',
        innerHTML: `
          window.__DISABLE_SMART_CAPTCHA__ = true;
          window.host = "https://ns-vasha-zashchita.rgs.ru";
        `,
      })
      defaultHead.script.push({
        type: 'text/javascript',
        defer: 'defer',
        fetchpriority: 'low',
        src: 'https://ns-vasha-zashchita.rgs.ru/static/js/main.js',
      })
    }
    // const path = this.$route?.path || ''
    // if (
    //   path.includes('/auto/ekasko/calc') ||
    //   path.includes('/auto/osago/kalkylator-osago')
    // ) {
    //   defaultHead.script.push({
    //     type: 'text/javascript',
    //     src: 'https://l.rgs.ru/content/cc4062f0/imgcache.js',
    //     defer: 'defer',
    //   })
    // }
    return defaultHead
  },
  mounted() {
    if (this.experiments) {
      window.ym(396811, 'experiments', this.experiments)
    }
    setTimeout(() => yaHitPage(), 20)
    if (this.setThemeOnClient) {
      this.setThemeOnClient = false
      this.$store.commit('settings/SET_THEME', this.theme)
    }
    if (window.flocktory?.reInit) {
      window.flocktory.reInit()
    }
  },
})
